import { KeyboardArrowRight } from '@mui/icons-material';
import { Typography } from '@mui/material';
import styled, { css, keyframes } from 'styled-components';

export const slideIn = keyframes`
  from {
    width: 0;
    opacity: 0;
  }

  50% {
    opacity: 0;
  }
  
  to {
    width: 500px;
    opacity: 1;
  }
`;

export const slideOut = keyframes`
  from {
    width: 500px;
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  to {
    width: 0;
    opacity: 0;
  }
`;

export const StyledDrawer = styled.dialog`
  position: absolute;
  display: flex;
  flex-direction: column;
  height: 460px;
  width: 100%;
  background: white;
  margin: 0;
  border: 0;
  padding: 0;
  /* top: 104px; */
  left: auto;
  z-index: 200;
  animation: ${({ open }) => (open ? slideIn : slideOut)} 0.4s;
`;

export const Container = styled.div`
  position: absolute;
  height: 550px;
  width: 424px;
  left: 450px;
  top: 16px;
  z-index: 1;
  border-radius: 8px;
  background-color: white;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 10px 16px;
  background-color: var(--luft-primary);
  color: white;
  display: flex;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  & i {
    font-weight: bold;
    font-size: 21px;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const HeaderText = styled.span`
  flex: 1;
  font-weight: 400;
  font-size: 16px;
`;

export const TabContainer = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 16px;
`;

export const TabButton = styled.div`
  padding: 0 0 8px 0;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--luft-primary);
  cursor: pointer;
  opacity: 0.5;
  gap: 6px;

  &:hover {
    opacity: 0.7;
  }

  ${({ active }) => active && css`
    opacity: 1;
    border-bottom: 2px solid var(--luft-primary)
  `}
`;

export const SliderContainer = styled.div`
  padding: 16px;
`;

export const SectionContainer = styled.div`
  padding: 0 16px;
  height: ${({ byNf }) => (byNf ? '460px' : 'unset')};
  overflow-y: ${({ byNf }) => (byNf ? 'scroll' : 'unset')};
  display: flex;
  flex-direction: column;

  ${({ borderTop, borderTopColor }) => borderTop && css`
    padding-top: 16px;
    margin-top: 16px;
    border-top: 1px solid ${borderTopColor};
  `}

  ${({ borderBottom, borderBottomColor }) => borderBottom && css`
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid ${borderBottomColor};
  `}
  
  ${({ paddingBottom }) => paddingBottom && css`
    padding-bottom: 24px;
  `}

  ${({ paddingTop }) => paddingTop && css`
    padding-top: 24px;
  `}


  ${({ bordered, borderColor }) => bordered && css`
    border: 1px solid ${borderColor};
    border-radius: 4px;
    margin: 24px;
    padding: 8px 24px;
    text-align: center;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  `}
`;

export const SliderCardWrapper = styled.div`
`;

export const SliderTitle = styled.h1`
  text-align: ${({ center }) => (center ? 'center' : 'inherited')};
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: var(--luft-primary);
  margin-bottom: 0;
  margin: ${({ noMargin }) => (noMargin ? '0' : '0 0 16px 0')};

  ${({ flex }) => flex && css`
    flex: 1;
  `}
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SliderInfo = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  color: var(--dark-blue);
  display: flex;
  justify-content: start;
`;

export const SliderFooterContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: 16px;
`;

export const SliderFooter = styled.div`
  padding: 4px;
  border: 1px solid var(--luft-secondary-darker);
  border-radius: 16px;
  width: fit-content;
`;

export const SlideNumber = styled.p`
  text-align: center;
  color: var(--luft-secondary-darker);
  font-weight: bold;
  font-size: 9px;
  line-height: 9px;
  margin: 0;
`;

export const ContentContainer = styled.div`
  overflow: auto;
  max-height: 460px;
`;

export const ChipContainer = styled.div`
  height: 24px;
  border-radius: 100px;
  background-color: ${({ backgroundColor }) => (backgroundColor || '')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoTitle = styled.span`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  font-size: ${({ small }) => (small ? '12px' : '16px')};
  font-size: ${({ medium }) => (medium && '14px')};
  line-height: 16px;
  color: ${({ color }) => (color || '')};
  margin-bottom: 4px;
  text-transform: ${({ uppercase }) => (uppercase ? 'uppercase' : 'inherit')};
  min-height: ${({ minHeight }) => (`${minHeight}px` || '0')};

  ${({ backgroundColor }) => backgroundColor && css`
    background-color: ${backgroundColor};
    padding: 4px 8px;
    border-radius: 4px;
    width: fit-content;
  `};
`;


export const ContentWrapper = styled.div`
  padding: ${({ noPadding }) => (noPadding ? '0' : '16px 0')};
  
  ${({ backgroundColor }) => backgroundColor && css`
    background-color: ${backgroundColor};
  `}

  ${({ bordered }) => bordered && css`
    border: 1px solid var(--secondary-gray);
    border-radius: 8px;
    padding: 16px;
  `}

  ${({ row }) => row && css`
    display: flex;
    flex-direction: row;
    gap: 16px;
  `}

  ${({ flex }) => flex && css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `}
`;

export const NfContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 32px;

  &:hover {
    opacity: 0.7;
  }
`;

export const NfId = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
`;

export const Tooltip = styled.div`
  visibility: hidden;
  color: white;
  position: absolute;
  bottom: calc(100% + 10px);
  right: 0;
  padding: 5px 5px;
  border-radius: 4px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s, padding 0.5s ease-in-out;

  &:before {
    content: "";
    width: 0;
    height: 0;
    right: 7px;
    bottom: -5px;
    position: absolute;
    border: 5px solid transparent;
    transform: rotate(315deg);
    transition: border 0.5s ease-in-out;
  }
`;

export const ShippingCompanyIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const DriverInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 16px;

  i {
    font-size: 24px;
    color: var(--luft-secondary-darker);
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }

    &:hover + ${Tooltip} {      
      visibility: visible;
      color: white;
      background-color: var(--light-opacity-dark);
      padding: 8px 8px;

      &:before {
        border-color: transparent transparent var(--light-opacity-dark) var(--light-opacity-dark);
      }
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TransportInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DriverInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 0;
`;

export const DriverInfoWrapperSecondary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding-right: 0;
  gap: 4px;
`;

export const DestinationName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 350px;
  color: var(--luft-primary);
  font-size: 16px;
`;

export const FooterInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: 32px;
  margin-top: 16px;
`;

export const FooterInfoTypography = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  font-family: 'Work Sans';
`;

export const FileImage = styled.img`
  width: 24px;
  height: 24px;
`;

export const StyledKeyboardArrowRight = styled(KeyboardArrowRight)`
  width: 24px;
  height: 24px;
  color: #000;
`;
